export const Settings = {
    DomainServerUrl: "https://domain-azuretest.bloyal.io",
    SiteType: "Development",
    BackOfficeReturnUrl: "https://bldev-posreact.azurewebsites.net",
    BackOfficeReturnLocalHostUrl: "http://localhost:3001",
}